import React, { useEffect, useState } from 'react';
import { useNavigate  } from 'react-router-dom';
import Default_logo from "../assets/images/default_logo.png";

const ProviderDetails = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);


      useEffect(() => {
    // Retrieve the user object from localStorage
    const userJson = localStorage.getItem('selectedUser');
    if (userJson) {
      setUser(JSON.parse(userJson));
    }
  }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (!user) {
        return <div className="no-user">No user details found</div>;
    }
    const handleContactClick = () => {
        navigate('/ContactSalesForm', {
            state: { providerDetails: user._id }, // Pass the provider email
        });
    };
    


    return (
        <div className="provider-details-container">
            <h1 className="header">Provider Details</h1>

            {/* Company logo at the top */}
            {user.company_logo ? (
                <div className="logo-container">
                    <img
                        src={`data:image/png;base64,${user.company_logo}`}
                        alt="Company Logo"
                        className="company-logo"
                    />
                </div>
            ) : (
                <img
                    src={Default_logo}
                    alt="Default logo"
                    style={{ width: "40px", height: "40px", objectFit: "contain", marginBottom: "15px" }}
                />
            )}

            <div className="user-details">
                {/* {user.company && (
                    <div className="detail-item">
                        <strong>Company:</strong> {user.company}
                    </div>
                )}
                {user.companywebsite && (
                    <div className="detail-item">
                        <strong>Company Website:</strong>{' '}
                        <a href={user.companywebsite} target="_blank" rel="noopener noreferrer">
                            {user.companywebsite}
                        </a>
                    </div>
                )}
                {user.firstname && (
                    <div className="detail-item">
                        <strong>First Name:</strong> {user.firstname}
                    </div>
                )}
                {user.lastname && (
                    <div className="detail-item">
                        <strong>Last Name:</strong> {user.lastname}
                    </div>
                )} 
                {user.address && (
                    <div className="detail-item">
                        <strong>Address:</strong> {user.address}
                    </div>
                )}*/}
                  {user.GeoWGS84_partner_no && (
                    <div className="detail-item">
                        <strong>GeoWGS84 Partner No:</strong> {user.GeoWGS84_partner_no}
                    </div>
                )}
                 {user.city && (
                    <div className="detail-item">
                        <strong>City:</strong> {user.city}
                    </div>
                )}
                {user.state && (
                    <div className="detail-item">
                        <strong>State:</strong> {user.state}
                    </div>
                )}
                {user.ZIPCode && (
                    <div className="detail-item">
                        <strong>ZIP Code:</strong> {user.ZIPCode}
                    </div>
                )}
                {user.country && (
                    <div className="detail-item">
                        <strong>Country:</strong> {user.country}
                    </div>
                )}
                {/* {user.email && (
                    <div className="detail-item">
                        <strong>Email:</strong> {user.email}
                    </div>
                )}
                {user.phonenumber && (
                    <div className="detail-item">
                        <strong>Phone Number:</strong> {user.phonenumber}
                    </div>
                )}
                {user.companydetails && (
                    <div className="detail-item">
                        <strong>Company Details:</strong> {user.companydetails}
                    </div>
                )} */}
                 {user.drones_do_you_have && user.drones_do_you_have.length > 0 && (
                    <div className="detail-item">
                        <strong>Drones:</strong>
                        <ul>
                            {user.drones_do_you_have.map((drones_do_you_have, index) => (
                                <li key={index}>{drones_do_you_have}</li>
                            ))}
                        </ul>
                    </div>
                )}
                {user.services && user.services.length > 0 && (
                    <div className="detail-item">
                        <strong>Services:</strong>
                        <ul>
                            {user.services.map((service, index) => (
                                <li key={index}>{service}</li>
                            ))}
                        </ul>
                    </div>
                )}
                {user.geometryfile && (
                    <div className="detail-item">
                        <strong>Service Area KML File:</strong> 
                        <a href={user.geometryfile} target="_blank" rel="noopener noreferrer">
                            {user.geometryfile}
                        </a>
                    </div>
                )}
            </div>
            <div className="contact-sales-button">
            <button onClick={handleContactClick} className="btn btn-primary">
                Contact Our Sales Team
            </button>
            </div>
        </div>
    );
};

export { ProviderDetails };